// extracted by mini-css-extract-plugin
export default {"root":"styles_root__No7op","img":"styles_img__ypaLp"};